import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import {LeftOutlined} from "@ant-design/icons";
import {Button} from "antd";

import StepsWrapper from "../../../components/StepsWrapper";
import CarDetailsForm from "../../../components/car/CarDetailsForm";
import CarSpecsForm from "../../../components/car/CarSpecsForm";
import CarReviewCardsWrapper from "../../../components/car/CarReviewCardsWrapper";
import PageTitle from "../../../components/page/PageTitle";
import {addCar} from "../../../helpers/car";
import {messageType, showMessages} from "../../../helpers/message";
import {getCarRateClasses} from "../../../helpers/option";
import {ucFirst} from "../../../helpers/misc";

import "./CarAdd.less";

const CarAdd = () => {
    const abortControllerRef = useRef(new AbortController());
    const abortSignalRef = useRef(abortControllerRef.current.signal);

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);

    const [car, setCar] = useState({
            number: undefined,
            licence_plate: undefined,
            friendly_name: undefined,
            vin: undefined,
            make: undefined,
            model: undefined,
            year: undefined,
            colour: undefined,
            seats: undefined,
            rate_class: undefined,
            isLoading: false,
            currentStep: 0,
            availableRateClasses: [],
    });

    const [availableRateClasses, setAvailableRateClasses] = useState([]);

    useEffect(() => {
        const loadRateClasses = async () => {
            const abortSignal = abortSignalRef.current;
            setLoading(true);

            try {
                let data = await getCarRateClasses(abortSignal);
                if (data) {
                    let rateClassNames = data.map((rateClasses) => {
                        return ucFirst(rateClasses.name);
                    });

                    setAvailableRateClasses(rateClassNames);

                    setCar(prevState => ({
                        ...prevState,
                        availableRateClasses: rateClassNames
                    }))
                }

                setLoading(false);
            } catch (error) {
                setLoading(false);
                showMessages(error.message, messageType.error);
            }
        };

        loadRateClasses();
    },[]);


    const goNext = (state) => {
        setCar(prevState => ({
            ...prevState,
            ...state
        }));

        setCurrentStep(currentStep + 1);
    };

    const goBack = (e) => {
        e.preventDefault(); //avoid unwanted form submission

        setCurrentStep(currentStep - 1);
    };

    const handleFinish = async () => {
        const abortSignal = abortSignalRef.current;
        setLoading(true);

        try {
            const response = await addCar(car);

            if (abortSignal.aborted === false && response) {
                const id = response.id;
                showMessages('Vehicle has successfully been added to the fleet!', messageType.success);
                navigate('/fleet/car?id=' + id, {replace: true})
            }

            setLoading(false);
        } catch (error) {
             setLoading(false);
            showMessages(error.message, messageType.error);
        }
    }

    const steps = [
        {
            title: 'Details',
            content:
                <CarDetailsForm
                    car={car}
                    availableRateClasses={availableRateClasses}
                    onSubmit={goNext}
                />
            ,
            form: 'car-details',
        },
        {
            title: 'Specs',
            content:
                <CarSpecsForm
                    car={car}
                    onSubmit={goNext}
                />,
            form: 'car-specs',
        },
        {
            title: 'Review',
            content: <CarReviewCardsWrapper car={car}/>,
        },
    ];

    return (
        <>
            <div className="car-add-header">
                <Button icon={<LeftOutlined/>} onClick={() => navigate(-1)}/>
                <PageTitle title="Add New Vehicle"/>
            </div>
            <StepsWrapper
                steps={steps}
                goBack={goBack}
                isLoading={loading}
                currentStep={currentStep}
                submitText="Create Vehicle"
                handleFinish={handleFinish}
            />
        </>
    )
}

export default CarAdd;
